import { HIDDEN_PERMISSIONS } from "./constants";
export var removeHiddenPermissions = function (permissions) {
    return permissions.filter(function (_a) {
        var name = _a.name;
        return !HIDDEN_PERMISSIONS.includes(name);
    });
};
